import { reducer as formReducer } from 'redux-form';

import userProfile from './containers/UserProfile/reducer';
import localeSettings from './containers/LocaleSettings/reducer';

import app from './containers/App/reducer';
import auth from './containers/Auth/reducer';
import pagesHistory from './containers/PagesHistory/reducer';
import pageEditor from './containers/PagesHistory/PageEditor/reducer';
import pagesCalendar from './containers/PagesHistory/PagesHistoryCalendar/reducer';
import pagesHistoryHome from './containers/PagesHistory/PagesHistoryHome/reducer';
import { auditReducer as syncLogs } from './containers/PagesHistory/AuditLog';
import modal from './modules/modal/reducer';
import { connectRouter } from 'connected-react-router';

import produce, { setAutoFreeze } from 'immer';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { Reducer, combineReducers } from 'redux';

export const immerReducer = (reducer: Reducer) => {
  const initialState = reducer(undefined, {} as any);
  return produce(reducer, initialState);
};

setAutoFreeze(false);

export const stateBlackList = ['localeSettings', 'app', 'modal', 'form', 'auth', 'router', 'pagesCalendar'];

export const persistReducers = (reducers: any, blacklist: readonly string[]) => {
  const persistedReducers = { ...reducers };

  for (const key in persistedReducers) {
    if (persistedReducers.hasOwnProperty(key) && !blacklist.includes(key)) {
      const persistConfig = {
        key,
        storage,
      };

      persistedReducers[key] = persistReducer(persistConfig, persistedReducers[key]);
    }
  }

  return persistedReducers;
};

export const wrapImmerReducers = (reducers: any) => {
  const persistedReducers = { ...reducers };

  for (const key in persistedReducers) {
    if (persistedReducers.hasOwnProperty(key)) {
      persistedReducers[key] = immerReducer(persistedReducers[key]);
    }
  }

  return persistedReducers;
};

export default (history: any) => {
  const reducers = {
    userProfile,
    localeSettings,
    auth,
    router: connectRouter(history),
    pagesHistory,
    pageEditor,
    pagesCalendar,
    pagesHistoryHome,
    form: formReducer,
    modal,
    app,
    syncLogs,
  };

  const immerReducers = wrapImmerReducers(reducers);

  const persistedReducers = persistReducers(immerReducers, stateBlackList);

  return combineReducers(persistedReducers);
};



// WEBPACK FOOTER //
// ./src/reducers.ts